module.exports = __webpack_public_path__ + "static/img/pada.3f47c056.png";